<template>
  <div class='formContent' v-loading='loading'>
    <div class='pointBtn' v-if="sysAdmin !== 'noSysNoAdmin'">
      <ArrowButton @click='goRouter'>{{ $t('integration.record_point_data') }}</ArrowButton>
    </div>
    <!--  v-if="isStartPoint" -->
    <el-form v-if='!isShowEdit2 || recordArray.length > 0' ref='form' :model='dioForm' :rules='rules'
             label-width='120px'>
      <!-- <template v-if="isShow"> -->
      <template v-if='isShowEdit2'>
        <el-form-item :label="$t('public.table_scope')" prop='scopeId'
                      v-if='$store.state.type === 3 || $store.state.type === 2'>
                    <span class='textSpan'>
                        {{ dioForm.scopeName }}
                    </span>
        </el-form-item>

        <el-form-item :label="$t('integration.collection_unit')" prop='collectUnit'>
                    <span class='textSpan'>
                        {{ changeTextFn('collectUnit', dioForm.collectUnit) }}
                    </span>
        </el-form-item>
        <el-form-item :label="$t('integration.collection_strategy')" prop='strategy'>
                    <span class='textSpan'>
                        {{ changeTextFn('strategy', dioForm.strategy) }}
                    </span>
          <i class='el-icon-question' style='margin-left: 5px; cursor: pointer' :title='desc'></i>
        </el-form-item>
        <el-form-item :label="$t('integration.specified_time')" prop='weekDay'>
                    <span class='textSpan' v-for='item in dioForm.weekDay' :key='item'>
                        {{ ArrayStrFn(item) }}
                    </span>
        </el-form-item>
        <el-form-item :label="$t('integration.record_point')" prop='timePoint'>
                    <span class='textSpan' v-for='item in recordArray' :key='item'>
                        {{ item }}
                    </span>
        </el-form-item>

        <el-form-item>
          <el-button type='primary' @click="$emit('edit')">
            {{ $t('public.edit') }}
          </el-button>
        </el-form-item>
      </template>
      <template v-else>
        <el-form-item>
          <el-checkbox :label="$t('integration.open_record_point')" v-model='check' @change='startCheck'></el-checkbox>
        </el-form-item>
        <el-form-item v-show='check'>
          <el-checkbox :label="$t('integration.use_default_settings')" v-model='defaultCheck'
                       @change='changeDefaultFn'></el-checkbox>
        </el-form-item>
        <el-form-item v-show='!check'>
          <el-button type='primary' @click='closeResolveFn' v-if='dioForm.scopeName'>
            {{ $t('integration.confirm_close') }}
          </el-button>
        </el-form-item>
        <div v-show='check'>
          <el-form-item :label="$t('public.table_scope')" prop='scopeId'
                        v-if='$store.state.type === 3 || $store.state.type === 2'>
            <!-- <el-select v-model="dioForm.scopeId" style="width: 250px" @change="changeFn">
  <el-option
    v-for="item in scopeArray"
    :key="item.id"
    :label="item.name"
    :value="item.id"
  ></el-option>
</el-select> -->
            {{ dioForm.scopeName }}
          </el-form-item>

          <el-form-item :label="$t('integration.collection_unit')" prop='collectUnit'>
            <el-select v-model='dioForm.collectUnit' style='width: 250px'>
              <el-option v-for='item in unitArray' :key='item.code' :label='item.name' :value='item.code'></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('integration.collection_strategy')" prop='strategy'>
            <el-select v-model='dioForm.strategy' style='width: 250px' @change='changeStrategy'>
              <el-option v-for='item in strategyArray' :key='item.id' :label='item.name' :value='item.id'></el-option>
            </el-select>
            <i class='el-icon-question' style='margin-left: 5px; cursor: pointer' :title='desc'></i>
          </el-form-item>
          <el-form-item :label="$t('integration.specified_time')" prop='weekDay'>
            <div class='timePoint'>
              <div class='allChooze'>
                <el-checkbox v-model='checkAll' :indeterminate='isIndeterminate'
                             @change='handleCheckAllChange'></el-checkbox>
              </div>
              <div class='weekClass'>
                <el-checkbox-group v-model='dioForm.weekDay' @change='handleCheckedCitiesChange'>
                  <ul>
                    <li v-for='item in weekArray' :key='item.id' class='uk-flex' style='border-radius:2px'>
                      <span>{{ $t(item.text) }}</span>
                      <el-checkbox class='checkbox' :label='item.id' :key='item.id'>{{ vlueNull }}</el-checkbox>
                    </li>
                  </ul>
                </el-checkbox-group>
              </div>
            </div>
          </el-form-item>
          <el-form-item :label="$t('integration.record_point')" prop='timePoint'>
            <div class='timePointClass'>
              <div>
                <div class='recordPoint'>
                  <div class='content' v-for='(item, index) in recordArray' :key='index'>
                    <div class='recordContent'>{{ item }}</div>
                    <span class='iconClass' @click='deleteTimeFn(index)'>
                                            <i class='el-icon-close'></i>
                                        </span>
                  </div>
                </div>
              </div>
              <span class='downIcon' @click='handleDownFn'>
                                <i class='el-icon-caret-bottom'></i>
                                <div v-show='isChoozeTime' class='selectTime'>
                                    <div class='timeClass'>
                                        <div class='timehour'>
                                            <el-select v-model='value1' :placeholder="$t('public.please')">
                                                <el-option v-for='item in hourArray' :key='item' :label='item'
                                                           :value='item'></el-option>
                                            </el-select>
                                        </div>
                                        <span class='maohao'>:</span>
                                        <div class='timemin'>
                                            <el-select v-model='value2' :placeholder="$t('public.please')">
                                                <el-option v-for='item in minArray' :key='item' :label='item'
                                                           :value='item'></el-option>
                                            </el-select>
                                        </div>
                                        <div class='checkIcon' @click='handleConfrimFn'>
                                            <i class='el-icon-check'></i>
                                        </div>
                                    </div>
                                </div>
                            </span>
            </div>
          </el-form-item>
          <el-form-item>
            <el-button type='primary' @click='resolveFn' style='margin-right:15px'>
              {{ $t('public.save') }}
            </el-button>

            <el-button type='primary' @click="$emit('back')">
              {{ $t('integration.back') }}
            </el-button>
          </el-form-item>
        </div>
      </template>
      <!-- </template> -->
    </el-form>
    <div v-else>
      <!-- <span style="margin-left:10px;">{{ $t('integration.data_collection_record_is_not_enabled') }}</span> -->
      <br />

      <el-empty :description="$t('integration.data_collection_record_is_not_enabled')">
        <el-button type='primary' @click="$emit('update:isShowEdit2', false)">
          {{ $t('integration.edit') }}
        </el-button>
      </el-empty>
    </div>
  </div>
</template>

<script>
import { accessRangeTree } from '@/api/api.js'
import { carrierDetail, carrierRecordDetail, carrierStrategy } from '@/api/modules/record.js'

import { carrierApply, carrierClose, carrierCollectBoot, carrierDefaultBoot } from '@/api/modules/carrier.js'
import ArrowButton from '@/components/ArrowButton/ArrowButton.vue'

export default {
  props: ['detailObj', 'getCarrierType', 'isShowEdit2'],
  watch: {
    socpeId (newVal) {
      this.dioForm.scopeId = newVal + ''
    },
    isShowEdit2 (newVal) {
      this.check = !newVal
      this.isStartPoint = !newVal
      // this.getInitData(newVal);
    }
  },
  components: {
    ArrowButton
  },
  computed: {
    rules () {
      return {
        // scopeId: [{ required: true, message: $t('integration.customer_cannot_be_empty'), trigger: 'change' }],
        collectUnit: [{
          required: true,
          message: $t('integration.collection_unit_cannot_be_empty'),
          trigger: 'change'
        }],
        strategy: [{
          required: true,
          message: $t('integration.collection_unit_cannot_be_empty'),
          trigger: 'change'
        }],
        weekDay: [{
          required: true,
          message: $t('integration.collection_unit_cannot_be_empty'),
          trigger: 'change'
        }]
      }
    },
    /** 用于表示当前登录用户属于什么类型的角色 */
    sysAdmin () {
      const currentUser = this.$store.getters.userInfo.scope
      if (currentUser.sysScope && currentUser.sysAdmin) {
        // 系统管理员
        return 'isSysAdmin'
      } else if (currentUser.sysScope && !currentUser.sysAdmin) {
        // 系统非管理员
        return 'isSysNoAdmin'
      } else if ((!currentUser.sysScope && currentUser.scopeAdmin) || currentUser.type === 2) {
        // 非系统管理员 以及代理角色  代理角色是迭代7的需求添加
        return 'noSysIsAdmin'
      } else {
        // 非系统非管理员
        return 'noSysNoAdmin'
      }
    }
  },
  data () {
    return {
      scopeArray: [],
      unitArray: [],
      strategyArray: [],
      dioForm: {
        scopeId: '',
        weekDay: [],
        timePoint: '',
        collectUnit: '',
        strategy: ''
      },
      weekArray: [
        {
          id: '1',
          text: $t('public.monday'),
          check: false
        },
        {
          id: '2',
          text: $t('public.tuesday'),
          check: false
        },
        {
          id: '3',
          text: $t('public.wednesday'),
          check: false
        },
        {
          id: '4',
          text: $t('public.thursday'),
          check: false
        },
        {
          id: '5',
          text: $t('public.friday'),
          check: false
        },
        {
          id: '6',
          text: $t('public.saturday'),
          check: false
        },
        {
          id: '0',
          text: $t('public.sunday'),
          check: false
        }
      ],
      checkAll: false,
      isIndeterminate: false,
      checkedWeeks: [],
      recordArray: [],
      vlueNull: null,
      value1: '01',
      value2: '01',
      isChoozeTime: false,
      allChoozeArray: ['1', '2', '3', '4', '5', '6', '0'],
      hourArray: ['00', '01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23'],
      minArray: [
        '00',
        '01',
        '02',
        '03',
        '04',
        '05',
        '06',
        '07',
        '08',
        '09',
        '10',
        '11',
        '12',
        '13',
        '14',
        '15',
        '16',
        '17',
        '18',
        '19',
        '20',
        '21',
        '22',
        '23',
        '24',
        '25',
        '26',
        '27',
        '28',
        '29',
        '30',
        '31',
        '32',
        '33',
        '34',
        '35',
        '36',
        '37',
        '38',
        '39',
        '40',
        '41',
        '42',
        '43',
        '44',
        '45',
        '46',
        '47',
        '48',
        '49',
        '50',
        '51',
        '52',
        '53',
        '54',
        '55',
        '56',
        '57',
        '58',
        '59'
      ],
      desc: '',

      // -------------------------------
      check: false,
      defaultCheck: false,
      // isShow: false,
      // 是否开启采集记录点
      isStartPoint: false,
      // 加载
      loading: false
    }
  },
  created () {
    this.getInitData()
    this.getSence()
  },
  mounted () {
    // bus.$off('checkFn')
    // bus.$on('checkFn', () => {
    //   this.resolveFn();
    // })
  },
  methods: {
    /** 获取数据 */
    getSence () {
      if (this.scopeArray.length > 0) return
      const P1 = accessRangeTree({
        code: 'scope',
        type: 1
      })
      const P2 = carrierRecordDetail({
        code: 'acquisition_unit',
        type: 0
      })
      const P3 = carrierStrategy()
      Promise.all([P1, P2, P3]).then(res => {
        console.log(res)
        this.scopeArray = res[0].result.filter(item => {
          return item.id > 0
        })
        this.unitArray = res[1].result.map(item => {
          return {
            code: Number(item.code),
            name: item.name
          }
        })
        this.strategyArray = res[2].result
        this.desc = res[2].result[0].desc
      })
    },
    /** 全选 */
    handleCheckAllChange (val) {
      this.dioForm.weekDay = val ? this.allChoozeArray : []
      this.isIndeterminate = false
    },
    handleCheckedCitiesChange (value) {
      const checkedCount = value.length
      this.checkAll = checkedCount === this.weekArray.length
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.weekArray.length
    },
    handleDownFn () {
      this.isChoozeTime = !this.isChoozeTime
    },
    clearValidate () {
      this.$nextTick(() => {
        if (this.$refs.form) {
          try {
            this.$refs.form.resetFields()
          } catch (err) {
            console.log(err)
          }
        }
      })
    },
    async justify () {
      try {
        return await this.$refs.form.validate()
      } catch (error) {
        return false
      }
    },
    async resolveFn () {
      const flag = await this.justify()
      if (!flag) return
      if (this.recordArray.length === 0) return this.$message.warning($t('integration.record_point_cannot_be_empty'))
      const {
        id,
        scopeId,
        collectUnit,
        strategy,
        weekDay
      } = this.dioForm
      const timePoint = this.recordArray.join(',')
      const carrierId = this.detailObj.id
      const query = {
        id,
        scopeId,
        collectUnit,
        strategy,
        weekDay: weekDay.join(','),
        timePoint,
        carrierId
      }
      carrierApply(query, this.getCarrierType.id).then(({ result }) => {
        if (result === 200) {
          this.$message.success($t('integration.set_successfully'))
          // this.isShowDialog = false;
          this.getInitData()
        } else if (result === 404) {
          this.$message.error($t('integration.parameter_error'))
        } else if (result === 405) {
          this.$message.error(this.$t('public.unknown_error'))
        } else if (result === 500) {
          this.$message.error($t('integration.system_error'))
        }
        this.$emit('back')
      })
    },
    closeResolveFn () {
      this.$confirm(this.$t('integration.are_you_sure_to_close_the_acquisition_record_point?'))
        .then(() => {
          carrierClose({ id: this.detailObj.id }, this.getCarrierType.id).then(({ result }) => {
            if (result === 200) {
              this.$message.success($t('integration.closed_successfully'))
              // this.getInitData();
              this.dioForm = {
                scopeId: '',
                weekDay: [],
                timePoint: '',
                collectUnit: '',
                strategy: ''
              }
              this.recordArray = []
            } else if (result === 500) {
              this.$message.warning($t($t('integration.record_point_closed')))
            } else {
              this.$message.error($t('integration.system_error_c__please_contact_the_relevant_administrator'))
            }
          })
        })
        .catch(() => {
        })
    },
    handleConfrimFn () {
      const str = this.value1 + ':' + this.value2
      this.recordArray.push(str)
    },
    deleteTimeFn (index) {
      if (this.recordArray.length === 1) return this.$message.warning($t('integration.keep_at_least_one_point_in_time'))
      this.recordArray.splice(index, 1)
    },
    changeFn (scopeId) {
      carrierDetail({ scopeId: scopeId }).then(({ result }) => {
        if (result) {
          this.isChoozeTime = false
          // this.desc = result.desc || '';
          this.dioForm = { ...result }

          this.dioForm.weekDay = result.weekDay.split(',')
          this.recordArray = this.dioForm.timePoint.split(',')
          //  = true
          this.checkAll = this.dioForm.weekDay.length === 7
        }
        this.getSence()
      })
    },
    initData () {
      this.dioForm = {
        scopeId: '',
        weekDay: [],
        timePoint: '',
        collectUnit: '',
        strategy: ''
      }
      this.dioForm.scopeId = String(this.detailObj.sceneId)
      this.dioForm.scopeName = String(this.detailObj.fullPath.split('/')[0])
      this.recordArray = []
      this.checkAll = false
      this.clearValidate()
    },
    /** 开启记录点 */
    startCheck (bool) {
      // if (bool) {
      //   this.defaultCheck = bool;
      // }

      this.dioForm.scopeId = String(this.detailObj.sceneId)

      if (bool && this.defaultCheck) {
        this.changeDefaultFn(true)
      }
    },
    getInitData () {
      this.loading = true
      carrierCollectBoot({ id: this.detailObj.id || this.$route.query.id }, this.getCarrierType.id)
        .then(({ result }) => {
          if (result.state === 200) {
            this.check = true
            this.isChoozeTime = false
            this.isStartPoint = true
            // this.isShow = true;
            // this.desc = result['set'].desc;
            result.set.scopeId = String(result.set.scopeId)
            this.dioForm = { ...result.set }
            this.dioForm.weekDay = result.set.weekDay.split(',')

            this.recordArray = this.dioForm.timePoint.split(',')
            //  = true
            this.checkAll = this.dioForm.weekDay.length === 7
          } else if (result.state === 300) {
            // this.$message.error($t('integration.collection_record_is_not_opened'))
            this.isStartPoint = false
          } else {
            this.check = false
            // this.initData()
            // this.isShow = false;
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    changeTextFn (key, value) {
      switch (key) {
        case 'scopeId': {
          return this.ArrayFn(value, this.scopeArray, 'id') || this.$store.getters.userInfo.scope.sceneName
        }
        case 'collectUnit': {
          return this.ArrayFn(value, this.unitArray, 'code')
        }
        case 'strategy': {
          return this.ArrayFn(value, this.strategyArray, 'id')
        }
        // case 'weekDay':
        //   {
        //     return this.ArrayFn(value);
        //   }
        default:
          break
      }
    },
    ArrayFn (value, array, text) {
      let str = ''
      for (const item of array) {
        if (Number(value) === Number(item[text])) {
          str = item.name
          break
        }
      }
      return str
    },
    // 字符串
    ArrayStrFn (value) {
      switch (value) {
        case '1': {
          return $t('public.monday')
        }
        case '2': {
          return $t('public.tuesday')
        }
        case '3': {
          return $t('public.wednesday')
        }
        case '4': {
          return $t('public.thursday')
        }
        case '5': {
          return $t('public.friday')
        }
        case '6': {
          return $t('public.saturday')
        }
        case '0': {
          return $t('public.sunday')
        }
        default:
          break
      }
    },
    /** 使用采集点默认设置 */
    changeDefaultFn (bool) {
      this.initData()
      if (bool && this.check) {
        carrierDefaultBoot({ id: this.detailObj.sceneId }, this.getCarrierType.id).then(({ result }) => {
          if (result.state === 200) {
            this.isChoozeTime = false
            // this.desc = result['set'].desc;
            result.set.scopeId = result.set.scopeId + ''
            this.dioForm = {
              ...result.set,
              scopeName: this.dioForm.scopeName
            }

            this.dioForm.weekDay = result.set.weekDay.split(',')
            this.recordArray = this.dioForm.timePoint.split(',')
            //  = true
            this.checkAll = this.dioForm.weekDay.length === 7
            this.isIndeterminate = this.dioForm.weekDay.length > 0 && this.dioForm.weekDay.length < 7
            console.log(this.isIndeterminate)
          } else {
            this.$message.warning($t('integration.default_settings_not_found_c__please_contact_administrator'))
          }
        })
      } else {
      }
    },
    changeStrategy (itemID) {
      for (const item of this.strategyArray) {
        itemID === item.id ? (this.desc = item.desc) : ''
      }
    },
    /** 记录点 */
    goRouter () {
      const {
        fullPath,
        keycode,
        id
      } = this.detailObj
      const { href } = this.$router.resolve({
        path: '/pointData',
        query: {
          fullpath: fullPath + '/' + keycode,
          id
        }
      })
      window.open(href, 'newwindow', 'height=800,width=1280,top=100,left=200,toolbar=no,menubar=no,scrollbars=no, resizable=no,location=no, status=no')
    }
  }
}
</script>

<style lang='scss' scoped>
.formContent {
  min-height: 350px;
  position: relative;

  .pointBtn {
    position: absolute;
    z-index: 999;
    right: 0;
  }

  .textSpan {
    min-width: 70px;
    line-height: 20px;
    padding: 5px;
    box-sizing: border-box;
    border-radius: 2px;
    text-align: center;
    display: inline-block;
    background-color: var(--primary-color);
    color: #fff;
    margin-right: 8px;
  }
}

.timePoint {
  height: 40px;
  width: 100%;
  border: 1px solid #ccc;
  display: flex;
  box-sizing: border-box;

  .allChooze {
    width: 40px;
    height: 39px;
    text-align: center;
    line-height: 39px;
    border-right: 1px solid #ccc;
  }

  .weekClass {
    flex: 1;

    ul {
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      padding: 5px;
      box-sizing: border-box;

      li {
        // float: left;
        // border: 1px solid #ccc;
        // box-sizing: border-box;
        height: 100%;
        width: 80px;
        margin-right: 5px;

        span {
          width: 50px;
          height: 100%;
          text-align: center;
          display: inline-block;
          background-color: var(--primary-color);
          color: #fff;
          border-radius: 0px 0px 2px 2px;
        }

        .checkbox {
          display: inline-block;
          text-align: center;
          border: 1px solid #ccc;
          border-radius: 2px 2px 0 0;
          box-sizing: border-box;
          width: 30px;
          height: 28px;

          ::v-deep .el-checkbox__inner {
            margin-left: 7px;
          }
        }
      }
    }
  }
}

.timePointClass {
  display: flex;
  align-items: center;

  .downIcon {
    cursor: pointer;
    position: relative;

    i {
      font-size: 22px;
      font-weight: bold;
    }

    .selectTime {
      position: absolute;
      top: 33px;
      width: 240px;
      left: -1px;
      height: 40px;
      border: 1px solid #ccc;
      z-index: 9999;
      background-color: white;
    }

    .timeClass {
      display: flex;
      height: 100%;
      width: 100%;

      .timehour,
      .timemin {
        flex: 1;
        padding: 0 5px;
        padding-top: 4px;
      }

      .checkIcon {
        width: 40px;
        height: 100%;
        text-align: center;
        line-height: 46px;
        border-left: 1px solid #ccc;
      }

      .maohao {
        line-height: 40px;
      }
    }
  }
}

.recordPoint {
  min-height: 40px;
  min-width: 60px;
  padding: 5px;
  padding-top: 0;
  border: 1px solid #ccc;
  display: flex;
  flex-wrap: wrap;
  box-sizing: border-box;

  .content {
    display: flex;
    margin-right: 5px;
    margin-top: 5px;
  }

  .recordContent {
    width: 60px;
    height: 28px;
    background-color: var(--primary-color);
    color: #fff;
    text-align: center;
    border-radius: 2px 0px 0px 2px;
  }

  .iconClass {
    display: inline-block;
    width: 26px;
    height: 26px;
    border: 1px solid #ccc;
    text-align: center;
    cursor: pointer;
    border-radius: 0px 2px 2px 0px;

    i {
      font-weight: bold;
    }
  }
}
</style>
